import React from "react";
import { useNavigate } from "react-router-dom";

import FollowupDetail from "../components/followups/FollowupDetail";

export default function FollowupDetailPage() {

  const navigate = useNavigate();

  return (
    <div>

      <button
        className="btn btn-light mb-3"
        onClick={() => navigate("/ppe/fms/followups")}
      >
        ← Back to List
      </button>

      <FollowupDetail />

    </div>
  );
}
